module.exports = false;


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 3